// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1":"cbfcb084","425":"430c5e42","885":"9fabe797"}[chunkId] + ".css";
};